import { render } from "./SuccesMessage.vue?vue&type=template&id=601e6adf&scoped=true"
import script from "./SuccesMessage.vue?vue&type=script&lang=js"
export * from "./SuccesMessage.vue?vue&type=script&lang=js"

import "./SuccesMessage.vue?vue&type=style&index=0&id=601e6adf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601e6adf"]])

export default __exports__